import Ajax from "./Ajax"
const GetBlogType = async() => {
    const response = await Ajax({
        url: `/blog/getBlogType?limit=false`,
        token: true
    })
    return response.data.result
}
export default GetBlogType